import { httpApi } from '@api/http.api.ts';
import type {
    DashboardAccessItem,
    DashboardAccessItemData,
} from '@routes/sidebar/admin-center/tenant-client/___pages___/___shared___/types.ts';

export interface FleetDashboardAccessItem extends DashboardAccessItem {
    shoreUsers: DashboardAccessItemData[];
}

export interface InsertFleetDashboardAccessRequest {
    vesselGroupIds: number[];
    shoreUserIds: number[];
    isActive: boolean;
}

const getBaseUrl = (tenantAlias: string) => `admin-center/tenants/${tenantAlias}/rbac/fleet-dashboard-access`;

export const getApiFleetDashboardAccess = (tenantAlias: string): Promise<FleetDashboardAccessItem[]> =>
    httpApi.get<FleetDashboardAccessItem[]>(getBaseUrl(tenantAlias)).then(({ data }) => data);

export const createApiFleetDashboardAccess = (
    tenantAlias: string,
    payload: InsertFleetDashboardAccessRequest,
): Promise<FleetDashboardAccessItem> =>
    httpApi.post<FleetDashboardAccessItem>(getBaseUrl(tenantAlias), payload).then(({ data }) => data);

export const updateApiFleetDashboardAccess = (
    tenantAlias: string,
    accessId: number,
    payload: InsertFleetDashboardAccessRequest,
): Promise<FleetDashboardAccessItem> =>
    httpApi.put<FleetDashboardAccessItem>(`${getBaseUrl(tenantAlias)}/${accessId}`, payload).then(({ data }) => data);

export const deleteApiFleetDashboardAccess = (tenantAlias: string, accessId: number): Promise<any> =>
    httpApi.delete<any>(`${getBaseUrl(tenantAlias)}/${accessId}`).then(({ data }) => data);
